import api from './axiosService';

export const shopApi = {
    getAll(params = {}) {
        return api.get('/shops', { params });
    },

    getById(shopId) {
        return api.get(`/shops/${shopId}`);
    },

    create(data) {
        return api.post('/shops', data);
    },

    register(data) {
        return api.post('/shops/register', data);
    },

    update(shopId, data) {
        return api.put(`/shops/${shopId}`, data);
    },

    toggleStatus(shopId) {
        return api.patch(`/shops/${shopId}/toggle-status`);
    },

    getTypes() {
        return api.get('/shops/types');
    },
};